import PropTypes from 'prop-types';
import { useState } from 'react';

function IconEdit({
  className,
  width,
  height,
  id,
  color,
  hoverColor,
  viewBox,
  ...props
}) {
  const [mainColor, setMainColor] = useState(color);
  return (
    <svg
      className={className}
      xmlns="http://www.w3.org/2000/svg"
      xmlnsXlink="http://www.w3.org/1999/xlink"
      width={width}
      height={height}
      viewBox={viewBox}
      onMouseEnter={() => setMainColor(hoverColor)}
      onMouseLeave={() => setMainColor(color)}
      {...props}
    >
      <defs>
        <path
          id="icon-edit"
          d="M4.818 16.91h3.273a.747.747 0 00.573-.246l9-9a.79.79 0 000-1.146L14.39 3.245a.79.79 0 00-1.146 0l-9 9a.743.743 0 00-.245.573v3.273c0 .49.327.818.818.818zm.818-3.765l8.182-8.181 2.127 2.127-8.181 8.182H5.636v-2.128zm14.728 7.037c0 .49-.328.818-.819.818H4.818c-.49 0-.818-.327-.818-.818 0-.491.327-.818.818-.818h14.727c.491 0 .819.327.819.818z"
        />
      </defs>
      <g fill="none" fillRule="evenodd">
        <mask id={id} fill="#FFF">
          <use xlinkHref="#icon-edit" />
        </mask>
        <use fillRule="nonzero" xlinkHref="#icon-edit" />
        <g fill={mainColor} mask={`url(#${id})`}>
          <path d="M0 0h24v24H0z" />
        </g>
      </g>
    </svg>
  );
}

IconEdit.defaultProps = {
  className: undefined,
  width: 24,
  height: 24,
  color: '#9CC100',
  hoverColor: '#fff',
  viewBox: '0,0,24,24',
};

IconEdit.propTypes = {
  className: PropTypes.string,
  width: PropTypes.number,
  height: PropTypes.number,
  id: PropTypes.string.isRequired,
  color: PropTypes.string,
  hoverColor: PropTypes.string,
  viewBox: PropTypes.string,
};

export default IconEdit;
